/**
 * A clean, single-layer 2D folder shape (tab + body in one path each) -
 * deliberately simplified back from an earlier, richer multi-layer
 * version (a separate back-panel + peeking paper edges) that cost more
 * time than it delivered and read as cluttered rather than richer.
 * Depth now comes from a single CSS drop-shadow on the whole icon (see
 * .folder-icon in FolderRail.css), not from stacked layers.
 *
 * Takes no color props - both paths reference the same CSS custom
 * properties (--folder-color / --folder-color-soft) already set inline
 * on the containing .folder-tile button (see FolderRail.js), so this
 * stays in sync with the existing color-assignment mechanism
 * automatically.
 */
export default function FolderIcon() {
  return (
    <svg className="folder-icon" viewBox="0 0 120 92" preserveAspectRatio="none" aria-hidden="true">
      <path
        className="folder-icon__body"
        d="M4 20 L4 12 Q4 8 8 8 L44 8 Q47 8 49 11 L54 18
           L94 18 Q102 18 102 26 L102 78 Q102 86 94 86 L12 86 Q4 86 4 78 Z"
      />
      <path className="folder-icon__tab" d="M4 20 L4 12 Q4 8 8 8 L44 8 Q47 8 49 11 L54 18 Z" />
    </svg>
  );
}